import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import Moment from 'react-moment';
import Image from "react-graceful-image";
import 'moment-timezone';
// import { autoPlay } from 'react-swipeable-views-utils';
import './ImageCarousel.css';
// const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const AutoPlaySwipeableViews = SwipeableViews;

const styles = theme => ({
  root: {
    maxWidth: 400,
    flexGrow: 1,
    margin: '0 auto'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 25,
    paddingLeft: theme.spacing.unit * 4,
    backgroundColor: theme.palette.background.default,
  },
  img: {
    height: 320,
    display: 'block',
    margin: '0 auto',
    // maxWidth: 400,
    overflow: 'hidden',
    // width: '100%',
  },
});

class SwipeableTextMobileStepper extends React.Component {
  state = {
    activeStep: 0,
  };

  handleNext = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep + 1,
    }));
  };

  handleBack = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1,
    }));
  };

  handleStepChange = activeStep => {
    this.setState({ activeStep });
  };

  render() {
    const { classes, theme, files } = this.props;
    const { activeStep } = this.state;
    const maxSteps = files ? files.length : 0;

    if(files && files.length > 0)
    return (
      <div className={classes.root}>
        <Paper square elevation={0} className={classes.header}>
          <Typography>Dateiname: {files[activeStep].originalname}</Typography>
        </Paper>
        <Paper square elevation={0} className={classes.header}>
          <Typography>Datum: <Moment format="DD.MM.YYYY HH:mm" date={files[activeStep].createdAt}/></Typography>
        </Paper>
        <AutoPlaySwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={this.handleStepChange}
          enableMouseEvents
        >
          {files.map((step, index) => (
            <div key={step._id}>
              {Math.abs(activeStep - index) <= 2 ? (
                <Image
                  src={`https://api.jde-mediabox.com/uploads/preview/${step.filename}`}
                  width="320"
                  height="320"
                  className={classes.img}
                  alt={step.originalname}
                  retry={{ count: 15, delay: 3, accumulate: "add" }}
                />
              ) : null}
            </div>
          ))}
        </AutoPlaySwipeableViews>
        <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          className={classes.mobileStepper}
          nextButton={
            <Button size="small" onClick={this.handleNext} disabled={activeStep === maxSteps - 1}>
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button size="small" onClick={this.handleBack} disabled={activeStep === 0}>
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </Button>
          }
        />
      </div>
    );
  else
    return null;
  }
}

SwipeableTextMobileStepper.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const ImageCarousel = withStyles(styles, { withTheme: true })(SwipeableTextMobileStepper);

export { ImageCarousel };